module.exports = __webpack_public_path__ + "img/player-draw.ab6859bf.svg";